// noinspection JSUnusedGlobalSymbols

import Chart from 'chart.js/auto'

export default class
{
	static init()
	{
		const option = Chart.defaults
		option.elements.bar.borderWidth = 1

		option.maintainAspectRatio = false
		option.responsive = true

		option.interaction.intersect = false
		option.interaction.mode = 'index'

		option.plugins.title.display = true

		this._purchase()
		this._product()
	}

	static _purchase()
	{
		$.get(`/index/data/purchase${location.search}`, (data) =>
		{
			data.type = 'bar'

			data.options.scales = {
				x: {
					stacked: true,
				},
				y: {
					stacked: true,
					ticks  : {
						precision: 0,
						callback : (value) => `${value.toLocaleString()}円`,
					},
				},
			}

			data.options.plugins.tooltip = {
				callbacks: {
					label : (context) => `${context.dataset.label} : ${context.parsed.y.toLocaleString()}円`,
					footer: (items) =>
					{
						let total = 0
						for(const bar of items) total += bar.raw

						return `合計 : ${total.toLocaleString()}円`
					},
				},
			}

			new Chart($('#graph_purchase'), data)
		})
	}

	static _product()
	{
		$.get(`/index/data/product${location.search}`, (data) =>
		{
			data.type = 'bar'

			data.options.scales = {
				x : {
					stacked: true,
				},
				y : {
					stacked : true,
					position: 'left',
					ticks   : {
						precision: 0,
						callback : (value) => `${value.toLocaleString()}個`,
					},
				},
				y1: {
					stacked : true,
					position: 'right',
					ticks   : {
						precision: 0,
						callback : (value) => `${value.toLocaleString()}円`,
					},
				},
			}

			data.options.plugins.tooltip = {
				callbacks: {
					label : (context) =>
					{
						const value = `${context.dataset.label} : ${context.parsed.y.toLocaleString()}`
						return value + (context.dataset.stack === 'count' ? '個' : '円')
					},
					footer: (items) =>
					{
						let price = 0
						let count = 0

						for(const bar of items)
						{
							if(bar.dataset.stack === 'count') count += bar.raw
							else price += bar.raw
						}

						return `合計 : ${price.toLocaleString()}円、${count.toLocaleString()}個`
					},
				},
			}

			new Chart($('#graph_product'), data)
		})
	}

	static reset(form)
	{
		form.customer_rank.value = ''
		form.subscription_rank.value = ''
		form.sex.value = ''
		form.product.value = ''

		form.submit()
	}
}
